angular
    .module('octopusApp.shared')
    .service('selectorDirective', function($templateCache) {
        function isMultipleSelector(attrs) {
            return attrs["multiple"] === "" || (!!attrs["multiple"] && attrs["multiple"] !== "false");
        }

        function isAllowedToClear(attrs) {
            return attrs["allowClear"] === "" || (!!attrs["allowClear"] && attrs["allowClear"] !== "false");
        }

        this.build = function(defaultPlaceholder, options) {
            options = options || {};
            return {
                restrict: 'E',
                replace: true,
                require: 'ngModel',
                scope: {
                    placeholder: "=",
                    available: "="
                },
                templateUrl: 'areas/shared/views/selector/select-template.html',
                controller: function() {
                    var vm = this;
                    vm.choiceTemplate =  options.choiceTemplate || 'areas/shared/views/selector/choice.html';

                    if (vm.isMultiple && !vm.selected){
                        vm.selected = [];
                    }
                    // Set Default Placeholder
                    if (!vm.placeholder || vm.placeholder === ''){
                        vm.placeholder = defaultPlaceholder;
                    }

                    vm.showControl = function showControl() {
                        return !!vm.available && (!vm.isMultiple || !!vm.selected);
                    };
                },
                compile: function($element, attrs) {
                    var isMultiple = isMultipleSelector(attrs);
                    var canClear = isAllowedToClear(attrs);
                    var $uiSelect = $("ui-select", $element);
                    var $uiSelectChoices =  $("ui-select-choices", $element);
                    var $uiSelectMatch = $("ui-select-match", $element);

                    // Needs to be explicitly reapplied due to remapping of model
                    if (attrs.hasOwnProperty('noDirtyCheck')) {
                        $uiSelect.attr('no-dirty-check', '');
                    }

                    if (isMultiple) {
                        $uiSelect.attr("multiple", "true");
                    }

                    var matchTemplate =  options.matchTemplate || 'areas/shared/views/selector/match.html';
                    // This needs to be done since ui-select for some reason uses a different binding
                    // property depending on if the control is a multiple or single selector.
                    // This allows template to just use `$template` and replace accordingly.
                    var template = $templateCache.get(matchTemplate);
                    if(!isMultiple) {
                        template = template.replace(/\$item/g,"$select.selected");
                    }
                    $uiSelectMatch.html(template);

                    if (!canClear) {
                        $uiSelectMatch.attr("allow-clear", "false");
                    }

                    if (options.isSimple) {
                        $uiSelectChoices.attr('repeat', $uiSelectChoices.attr('repeat').replace('item.Id as ', ''));
                    }

                    if (options.boundIdentity){
                        $uiSelectChoices.attr('repeat', $uiSelectChoices.attr('repeat').replace('item.Id as ', 'item.'+ options.boundIdentity +' as '));
                    }

                    return {
                        post: function ($scope, $element, attrs, ngModel) {
                            var vm = $scope.vm;
                            vm.isMultiple = isMultiple;
                            ngModel.$render = function onRender() { // Update internal selected if outer model changes
                                vm.selected = ngModel.$viewValue || (isMultiple ? [] : null);
                            };
                            vm.onChange = function onChange() { // Update outer model if internal model changes
                                ngModel.$setViewValue(vm.selected);
                            };
                        }
                    };
                },
                controllerAs: 'vm',
                bindToController: true
            };
        };
    })
    .directive('selectCustom', function(selectorDirective) {
        return selectorDirective.build('Select');
    }).directive('selectProjects', function(selectorDirective) {
        return selectorDirective.build('Any Project');
    }).directive('selectEnvironments', function(selectorDirective) {
        return selectorDirective.build('Any Environment');
    }).directive('selectTenants', function(selectorDirective) {
        return selectorDirective.build('Select Tenants');
    }).directive('selectChannels', function(selectorDirective) {
        return selectorDirective.build('Any Channel');
    }).directive('selectProjectGroups', function(selectorDirective) {
        return selectorDirective.build('Any Project Group');
    }) .directive('selectRoles', function(selectorDirective) {
        return selectorDirective.build('Any Role', {
            isSimple: true,
            choiceTemplate: 'areas/shared/views/selector/choice-role.html',
            matchTemplate:  'areas/shared/views/selector/match-role.html'
        });
    }) .directive('selectTags', function(selectorDirective) {
        return selectorDirective.build('Select Tags', {
            choiceTemplate: 'areas/shared/views/selector/choice-tag.html',
            matchTemplate:  'areas/shared/views/selector/match-tag.html',
            boundIdentity: 'CanonicalTagName'
        });
    }).directive('selectUsers', function($sanitize, selectorDirective) {
        return selectorDirective.build('Any User',
            {
                choiceTemplate: 'areas/shared/views/selector/choice-user.html',
                matchTemplate:  'areas/shared/views/selector/match-user.html'
            });
    }).directive('selectRelease', function (selectorDirective) {
        return selectorDirective.build('Show current releases',
            {
                choiceTemplate: 'areas/shared/views/selector/choice-release.html',
                matchTemplate:  'areas/shared/views/selector/match-release.html'
            });
    });

angular
    .module('octopusApp.shared')
    .directive('setSelectMatchColor', function() {
    return {
        restrict: 'EA',
        link: function ($scope, $element) {
            var item = $element.scope().$item;

            if (item) {
                $element.parents(".ui-select-match-item")
                    .css("background-color", item.Color);
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/select-template.js
// module id = 1819545803128744
// module chunks = 1